import { render, staticRenderFns } from "./Estrutura.vue?vue&type=template&id=620d1586&"
import script from "./Estrutura.vue?vue&type=script&lang=ts&"
export * from "./Estrutura.vue?vue&type=script&lang=ts&"
import style0 from "./Estrutura.vue?vue&type=style&index=0&id=620d1586&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports